import { default as TomSelect } from "tom-select"

window.initPodcastFinder = function () {
  const podcastSelect = new TomSelect('#podcast_url', {
    load: async function (query, callback) {
      const results = await fetch(`/api/show_lookup?q=${query}`);
      const json = await results.json();

      let collection = json.map(podcast => ({
        value: podcast.feedUrl,
        text: podcast.collectionName,
        artworkImage: podcast.artworkUrl600,
        title: podcast.collectionName,
        feedUrl: podcast.feedUrl
      }))

      collection.push({
        value: null,
        text: "My podcast isn't listed",
        artworkImage: null,
        title: query
      })
      callback(collection);
    },
    maxItems: 1,
    onChange: async function (value) {
      if (value == null) {
        return;
      }
      const item = podcastSelect.options[value];
      const preview = document.querySelector("#podcast-preview");

      preview.src =
        "/previews?&podcast_url=" +
        encodeURIComponent(value) +
        "&artwork=" +
        encodeURIComponent(item.artworkImage) +
        "&title=" +
        encodeURIComponent(item.title);
      document.querySelector("#podcast-preview").scrollIntoView();

      document.querySelector(
        ".sc-form.podcast input[type='submit']"
      ).disabled = false;

      const results = await fetch(`/sign_up/channel_exists?title=${item.title}&feedUrl=${item.feedUrl}`);
      const json = await results.json();

      if (json.channel_exists) {
        document.querySelector('#channel-title').innerHTML = item.title;
        document.querySelector('#channel-url').setAttribute('href', json.url);

        document.querySelector("#podcast-already-exists").classList.remove("hidden");
        document.querySelector("#podcast-metadata").classList.add("hidden");
        document.querySelector(
          ".sc-form.podcast input[type='submit']"
        ).classList.add("hidden");
      } else {
        document.querySelector("#podcast-already-exists").classList.add("hidden");
        document.querySelector("#podcast-metadata").classList.remove("hidden");
        document.querySelector(
          ".sc-form.podcast input[type='submit']"
        ).classList.remove("hidden");
      }
    }
  });
};


